import { action, computed, observable, runInAction } from 'mobx';
import { remove, upload } from 'services/cloudinary';
import { get } from '../../../services/request';
import listings from '../../../containers/Overview/stores/ListingsStore';

class SaleCreateStore {
  @observable agents = [];
  @observable selectedAgent;
  @observable isTest = false;
  @observable selfRegistration = false;
  @observable masterSaleId = '';

  @computed get canCreateSale() {
    return this.agents.length > 0 && this.user.hasReadWritePermissions;
  }

  @computed get config() {
    return this.user.userConfig;
  }

  constructor(user, sale, app) {
    this.user = user;
    this.sale = sale;
    this.app = app;

    this.selectedAgent = this.user.agentData();

    this.listings = listings;
  }

  async upload(file) {
    return await upload({
      file,
      accessToken: this.user.accessToken,
    });
  }

  async remove(deleteToken) {
    return await remove({
      deleteToken,
      accessToken: this.user.accessToken,
    });
  }

  @computed get masterSales() {
    var filtered = this.listings.items
      .filter((i) => i.features != null && !!i.features.isMasterSale)
      .map((s) => ({ key: s.id, text: s.title }));
    return filtered;
  }

  start(data) {
    const user = this.user;
    const app = this.app;

    const saleFeatures = app.getSaleFeatures({
      test: !!this.isTest,
      isMasterSale: this.masterSaleId === 'master',
      disableAutomaticReminders:
        !!this.masterSaleId && this.masterSaleId !== 'master',
      selfRegistration: !!this.selfRegistration,
    });

    const agentData = this.selectedAgent || user.agentData();

    const offerData = {
      ...(user.userConfig.defaultSaleOfferData || {}),
      objectno: data.number,
      object_address: data.address,
    };
    const item = {
      masterSaleId:
        !this.masterSaleId || this.masterSaleId === 'master'
          ? undefined
          : this.masterSaleId,
      referenceId: (data.number || '').toString(),
      itemData: data,
      offerData,
      agentData,
      mls: data.mls,
      inviteOnly: data.inviteOnly,
      offerForm: offerData.offer_form,
      features: saleFeatures,
    };
    if (app.data && app.data.sale_country)
      item.offerData.sale_country = app.data.sale_country;

    item.itemData.agent = Object.assign({}, item.agentData);
    this.sale.start(item);
  }

  @action async loadAgents() {
    try {
      const um =
        this.app.config &&
        this.app.config.userManagement &&
        this.app.config.userManagement.url
          ? this.app.config.userManagement.url
          : '';
      const result = await get(`${um}/users/lookup`, this.user.accessToken);
      runInAction(() => this.populateAgents(result));
    } catch (e) {}
  }

  populateAgents(agents) {
    this.agents = agents;

    const current = this.user.agentData();

    this.selectedAgent =
      this.agents.find((a) => String(a.sub) === String(current.sub)) ||
      this.agents.find(
        (a) =>
          (String(a.id) || String(a.agent_id)) === String(current.id) &&
          ((!a.office_id && !current.office_id) ||
            String(a.office_id) === String(current.office_id))
      ) ||
      (agents.length === 1 ? agents[0] : undefined);
  }
}

export { SaleCreateStore };



// WEBPACK FOOTER //
// ./src/app/components/SaleCreatePanel/stores/SaleCreateStore.js